import {putAdviserInCache} from 'hooks/advisers';
import api from 'services/Api';

export function declareAlive() {
  return api.invoke('PUT', '/core/v1/advisers/alive');
}

export async function updateAvailability(available) {
  await api.invoke(
    'PUT',
    '/core/v1/advisers/availability',
    {available},
    {
      api: {
        emitNotification: true,
      },
    },
  );
}

export async function fetchSkills(category) {
  const {data} = await api.invoke(
    'GET',
    '/core/v1/advisers/skills',
    undefined,
    {
      params: {
        category,
      },
    },
  );

  return data;
}

export async function fetchSkillsWithCount(category) {
  const {data} = await api.invoke(
    'GET',
    '/core/v1/advisers/skillsWithCount',
    undefined,
    category !== 'ALL' && {
      params: {
        category,
      },
    },
  );

  return data;
}
export async function fetchInitials(category) {
  const {data} = await api.invoke(
    'GET',
    '/core/v1/advisers/count/byLastNameInitial',
    undefined,
    {
      params: {
        category,
      },
    },
  );

  return data;
}

export async function fetchInstitutes() {
  const {data} = await api.invoke('GET', '/core/v1/advisers/institutes');

  return data;
}

export async function fetchInstitutesWithCount() {
  const {data} = await api.invoke(
    'GET',
    '/core/v1/advisers/institutesWithCount',
  );

  return data;
}

export async function fetchAdvisers(params) {
  const {data} = await api.invoke('GET', '/core/v1/advisers', undefined, {
    params,
  });

  for (const adviser of data.advisers) {
    putAdviserInCache(adviser);
  }

  return data;
}

export function fetchCategories() {
  return api.invoke('GET', '/core/v1/advisers/categories');
}

export async function fetchReferences() {
  const {data} = await api.invoke('GET', '/core/v1/advisers/references');

  return data;
}

export async function fetchComments(userId, offset, limit) {
  const {data} = await api.invoke(
    'GET',
    `/core/v1/advisers/${userId}/comments`,
    undefined,
    {
      params: {
        offset,
        limit,
      },
    },
  );

  return data;
}

export function abuseReports(userId, data) {
  return api.invoke('POST', `/core/v1/advisers/${userId}/abuseReports`, data);
}

export function notifyOnline(userId) {
  return api.invoke(
    'POST',
    `/core/v1/advisers/${userId}/notifyOnline`,
    undefined,
    {
      api: {
        emitNotification: true,
      },
    },
  );
}

export async function fetchTimetable(userId, type) {
  const {data} = await api.invoke(
    'GET',
    `/core/v1/advisers/${userId}/timetable`,
    undefined,
    {
      params: {
        type,
      },
      api: {
        emitNotification: true,
      },
    },
  );

  return data;
}

export function updateAdviser(data) {
  return api.invoke('PATCH', '/core/v1/advisers/profile', data, {
    api: {emitNotification: true},
  });
}

export function updateNotifByCall(data) {
  return api.invoke('PUT', '/core/v1/advisers/notifyByCall', data, {
    api: {emitNotification: true},
  });
}

export function updateAdvisingRate(acceptingMethod, data) {
  return api.invoke(
    'PUT',
    `/core/v1/advisers/rates/${acceptingMethod}`,
    {
      rate: data,
    },
    {api: {emitNotification: true}},
  );
}

export function updateAdvisingMethods(acceptingMethod, data) {
  return api.invoke(
    'PUT',
    `/core/v1/advisers/acceptingMethods/${acceptingMethod}`,
    {accepting: data},
    {api: {emitNotification: true}},
  );
}

export function addTimetable(data) {
  return api.invoke('POST', '/core/v1/advisers/timetable', data, {
    api: {
      emitNotification: true,
    },
  });
}
export function deleteTimetable(id) {
  return api.invoke('DELETE', `/core/v1/advisers/timetable/${id}`, null, {
    api: {
      emitNotification: true,
    },
  });
}

export function adviserStatistic() {
  return api.invoke('GET', `/core/v1/advisers/stats`);
}


export function getSkillPositions() {
  return api.invoke(
    'GET',
    '/core/v1/advisers/skills/positions',
  );
}

export function purchaseSkillPosition(skillId, position) {
  return api.invoke(
    'POST',
    `/core/v1/advisers/skills/${skillId}/positions/${position}/purchase`,
    {},
  );
}

export function getActiveSkillPositions() {
  return api.invoke(
    'GET',
    '/core/v1/advisers/skillPositions/active',
  );
}

export function getAvisersPositionsBySkillId(skillId) {
  if (skillId === null || skillId === undefined || skillId === '') {
    return Promise.resolve({data: []});
  }

  return api.invoke(
    'GET',
    `/core/v1/advisers/skills/${skillId}/advisers`,
  )
}